export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-6 text-center">
        <span className="inline-block text-xs font-medium text-accent-700 bg-accent-100 px-3 py-1 rounded-full mb-4">
          关于平台
        </span>
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-5">
          关于我们
        </h2>
        <div className="text-foreground-600 text-sm md:text-base leading-relaxed space-y-4">
          <p>
            17吃瓜网是一个专注于收集和分享全网最新吃瓜视频与黑料爆料的在线内容平台。
            我们致力于为广大吃瓜爱好者提供真实、快速、全面的吃瓜视频观看体验，
            覆盖网红动态、娱乐圈内幕、社会现场实拍等多元内容品类。
          </p>
          <p>
            平台始终坚持<strong>真实可靠、快速更新、用户至上</strong>的运营理念。
            编辑团队全天候追踪热点事件，确保每一条吃瓜视频都能第一时间触达用户。
            同时我们严格保护投稿人隐私，为每一位爆料者提供安全、匿名的投稿通道。
          </p>
          <p className="text-foreground-400">
            每日更新 &middot; 全品类覆盖 &middot; 免费观看 &middot; 匿名投稿
          </p>
        </div>
      </div>
    </section>
  );
}